import { Navigate, Route, useLocation } from 'react-router-dom';

/**
 * CAN-02: endereços das telas das versões antigas (ciclos até o 2S2024) e a rota da nova identidade que os atende.
 * As telas novas mostram todos os ciclos; um favorito ou link antigo cai na tela nova, sem trocar o ciclo do app.
 */
const ROTAS_DAS_VERSOES_ANTIGAS: [antiga: string, nova: string][] = [
  ['/v2/', '/'],
  ['/v2/realizacao-destaque', '/realizacao-destaque'],
  ['/v2/extrato', '/extrato'],
  ['/v2/minha-equipe/validar-apreciar-realizacao', '/minha-equipe/validar-apreciar-realizacao'],
  ['/v3/', '/'],
  ['/v3/realizacao-destaque', '/realizacao-destaque'],
  ['/v3/extrato', '/extrato'],
  ['/v3/acao-ecoa', '/acao-ecoa'],
  ['/v3/validar-acao-ecoa', '/validar-acao-ecoa'],
];

/** Leva à rota nova com a query string e o hash do endereço antigo (favoritos e e-mails com parâmetros). */
function IrParaARotaNova({ rota }: { rota: string }) {
  const { search, hash } = useLocation();

  return <Navigate to={{ pathname: rota, search, hash }} replace />;
}

/** As rotas das versões antigas, cada uma levando à nova (com `replace`, para o voltar não cair de novo nela). */
export function rotasDasVersoesAntigas() {
  return ROTAS_DAS_VERSOES_ANTIGAS.map(([antiga, nova]) => (
    <Route key={antiga} path={antiga} element={<IrParaARotaNova rota={nova} />} />
  ));
}
